// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Copy-to-clipboard, shared by the dataset surfaces (#206). */
.pcBbKlG_7Skdr2hgn5x3 {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    border: 1px solid var(--curio-border);
    border-radius: var(--curio-radius-sm);
    background: var(--curio-card-bg);
    color: var(--curio-text-secondary);
    cursor: pointer;
    font-size: var(--curio-font-size-sm);
    line-height: 1;
}

.pcBbKlG_7Skdr2hgn5x3:hover {
    background: var(--curio-page-bg);
    color: var(--curio-text-primary);
}

/* Square, for a dense palette row or a card's meta strip. */
.QZaNWHeBXfHdSphf5Z86 {
    padding: 4px 6px;
}

/* Icon plus text, for a details panel where there is room to name the action. */
.KsSTjBlvRzXuamU5TFqO {
    padding: 6px 10px;
}

.YzNTHl8lgmV4OWiIil7d {
    white-space: nowrap;
}

/* Confirmation reads as success rather than as another neutral control. */
.pcBbKlG_7Skdr2hgn5x3[data-copy-status="copied"] {
    color: var(--curio-success-text);
    border-color: var(--curio-success-text);
}

.pcBbKlG_7Skdr2hgn5x3[data-copy-status="failed"] {
    color: var(--curio-danger-text);
    border-color: var(--curio-danger-text);
}
`, "",{"version":3,"sources":["webpack://./src/components/CopyButton.module.css"],"names":[],"mappings":"AAAA,8DAA8D;AAC9D;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,qCAAqC;IACrC,qCAAqC;IACrC,gCAAgC;IAChC,kCAAkC;IAClC,eAAe;IACf,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA,4DAA4D;AAC5D;IACI,gBAAgB;AACpB;;AAEA,gFAAgF;AAChF;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,0EAA0E;AAC1E;IACI,gCAAgC;IAChC,uCAAuC;AAC3C;;AAEA;IACI,+BAA+B;IAC/B,sCAAsC;AAC1C","sourcesContent":["/* Copy-to-clipboard, shared by the dataset surfaces (#206). */\n.root {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    border: 1px solid var(--curio-border);\n    border-radius: var(--curio-radius-sm);\n    background: var(--curio-card-bg);\n    color: var(--curio-text-secondary);\n    cursor: pointer;\n    font-size: var(--curio-font-size-sm);\n    line-height: 1;\n}\n\n.root:hover {\n    background: var(--curio-page-bg);\n    color: var(--curio-text-primary);\n}\n\n/* Square, for a dense palette row or a card's meta strip. */\n.icon {\n    padding: 4px 6px;\n}\n\n/* Icon plus text, for a details panel where there is room to name the action. */\n.labelled {\n    padding: 6px 10px;\n}\n\n.text {\n    white-space: nowrap;\n}\n\n/* Confirmation reads as success rather than as another neutral control. */\n.root[data-copy-status=\"copied\"] {\n    color: var(--curio-success-text);\n    border-color: var(--curio-success-text);\n}\n\n.root[data-copy-status=\"failed\"] {\n    color: var(--curio-danger-text);\n    border-color: var(--curio-danger-text);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `pcBbKlG_7Skdr2hgn5x3`,
	"icon": `QZaNWHeBXfHdSphf5Z86`,
	"labelled": `KsSTjBlvRzXuamU5TFqO`,
	"text": `YzNTHl8lgmV4OWiIil7d`
};
export default ___CSS_LOADER_EXPORT___;
